import React from 'react';

export const RemoveStylingIcon = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 4.66666V3.99999H2.66683V4.66666C2.66683 5.03485 2.36835 5.33332 2.00016 5.33332C1.63197 5.33332 1.3335 5.03485 1.3335 4.66666V3.33332C1.3335 2.96513 1.63197 2.66666 2.00016 2.66666H10.6668C11.035 2.66666 11.3335 2.96513 11.3335 3.33332V4.66666C11.3335 5.03485 11.035 5.33332 10.6668 5.33332C10.2986 5.33332 10.0002 5.03485 10.0002 4.66666Z"
      fill="currentColor"
    />
    <path
      d="M6 12.6667V3.33332C6 2.96513 6.29848 2.66666 6.66667 2.66666C7.03486 2.66666 7.33333 2.96513 7.33333 3.33332V12.6667C7.33333 13.0348 7.03486 13.3333 6.66667 13.3333C6.29848 13.3333 6 13.0348 6 12.6667Z"
      fill="currentColor"
    />
    <path
      d="M7.99984 12C8.36803 12 8.6665 12.2985 8.6665 12.6667C8.6665 13.0349 8.36803 13.3333 7.99984 13.3333H5.33317C4.96498 13.3333 4.6665 13.0349 4.6665 12.6667C4.6665 12.2985 4.96498 12 5.33317 12H7.99984Z"
      fill="currentColor"
    />
    <path
      d="M13.3335 8.66668H10.6668C10.6668 9.03487 10.3684 9.33334 10.0002 9.33334C9.63197 9.33334 9.3335 9.03487 9.3335 8.66668V8.00001C9.3335 7.63182 9.63197 7.33334 10.0002 7.33334H14.0002C14.3684 7.33334 14.6668 7.63182 14.6668 8.00001V8.66668C14.6668 9.03487 14.3684 9.33334 14.0002 9.33334C13.632 9.33334 13.3335 9.03487 13.3335 8.66668Z"
      fill="currentColor"
    />
    <path
      d="M11.3335 12.6667V8.00001C11.3335 7.63182 11.632 7.33334 12.0002 7.33334C12.3684 7.33334 12.6668 7.63182 12.6668 8.00001V12.6667C12.6668 13.0349 12.3684 13.3333 12.0002 13.3333C11.632 13.3333 11.3335 13.0349 11.3335 12.6667Z"
      fill="currentColor"
    />
    <path
      d="M12.6665 12C13.0347 12 13.3332 12.2985 13.3332 12.6667C13.3332 13.0349 13.0347 13.3333 12.6665 13.3333H11.3332C10.965 13.3333 10.6665 13.0349 10.6665 12.6667C10.6665 12.2985 10.965 12 11.3332 12H12.6665Z"
      fill="currentColor"
    />
  </svg>
);
